import axios from '@axios';
import Vue from 'vue';
import LogsService from '@/services/LogsService';
import PrisonService from '@/services/PrisonService';

const userTokenKey = 'userTokenCell'; // changed keys as they clashed with portal names locally (used in router also)
const userKey = 'userCell';
export default {
  namespaced: true,
  state: {
    user: null,
    prison: null,
    wings: [],
  },
  getters: {
    getLocalUser() {
      return JSON.parse(localStorage.getItem(userKey));
    },
    getLocalUserToken() {
      return localStorage.getItem(userTokenKey);
    },
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_PRISON(state, prison) {
      state.prison = prison;
    },
    SET_WINGS(state, wing) {
      state.wings = wing;
    },
  },
  actions: {
    // eslint-disable-next-line
    clearLocalUser({ commit }) {
      localStorage.removeItem(userTokenKey);
      localStorage.removeItem(userKey);
      axios.defaults.headers.common.Authorization = null;
    },
    // eslint-disable-next-line
    setLocalUser({ commit }, user) {
      localStorage.setItem(userKey, JSON.stringify(user));
      commit('SET_USER', user);
    },
    // eslint-disable-next-line
    setLocalUserToken({ commit }, token) {
      localStorage.setItem(userTokenKey, token);
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    },
    setCurrentUserFromLocalStorage({ commit }) {
      const user = localStorage.getItem(userKey);

      if (user) {
        commit('SET_USER', JSON.parse(user));
      }
    },
    refreshUser({ dispatch }) {
      return LogsService.getMdmUser().then(res => {
        dispatch('setLocalUser', res.data);
        return res.data;
      }).catch(() => {
        Vue.$toast.error('Could not get user, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    refreshPrison({ commit, dispatch, state }) {
      return PrisonService.getPrison(state.user.prison_id).then(res => {
        commit('SET_PRISON', res.data);
        dispatch('refreshWings');
        return res.data;
      }).catch(() => {
        Vue.$toast.error('Could not get your establishment details, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    refreshWings({ commit }) {
      return PrisonService.getPrisonWings().then(res => {
        commit('SET_WINGS', res.data);
        return res.data;
      }).catch(() => {
        Vue.$toast.error('Could not get your establishment wing details, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
  },
};
